export const loginState = {
    ok: "ok",
    loading: "loading",
    error: "error"
};
